export default __webpack_public_path__ + "static/media/bmw_offer3.86ec05ff.jpg";